import { getAccessToken } from './auth';

export const NPS_RESULTS_URL = 'https://fp-api.focuspointintl.com/api/npsResults';

export function broadcastNpsUnresolvedCount(unresolved) {
  if (typeof unresolved !== 'number') return;
  window.dispatchEvent(new CustomEvent('nps-unresolved-count', { detail: { unresolved } }));
}

export async function fetchNpsUnresolvedCount() {
  const accessToken = await getAccessToken();
  if (!accessToken) return null;

  const params = new URLSearchParams({ page: '1', unresolved: 'true' });
  const response = await fetch(`${NPS_RESULTS_URL}?${params}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!response.ok) return null;

  const data = await response.json();
  return typeof data.unresolved === 'number' ? data.unresolved : null;
}

export async function updateNpsResult(id, body) {
  const accessToken = await getAccessToken();
  if (!accessToken) throw new Error('Could not get access token');

  const response = await fetch(`${NPS_RESULTS_URL}/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || 'Failed to update NPS result');
  }

  return response.json();
}
